const useModel23Authorization = (model23) => {
    const newRecord = model23.id === null || model23.id === undefined;

    return {
        edit: newRecord || Boolean(model23.authorization?.update),
        update: Boolean(model23.authorization?.update),
        delete: Boolean(model23.authorization?.delete),
        confirm: Boolean(model23.authorization?.confirm),
    }
}

export default useModel23Authorization;